import { push } from 'connected-react-router';

import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';
import { hideAddFormModal } from './addFormModal';

export const ADD_FORM_REQUEST = 'ADD_FORM_REQUEST';
export const ADD_FORM_SUCCESS = 'ADD_FORM_SUCCESS';
export const ADD_FORM_FAILURE = 'ADD_FORM_FAILURE';
export const RESET_ADDING_FORM = 'RESET_ADDING_FORM';

function requestAddForm() {
  return {
    type: ADD_FORM_REQUEST,
    isAddingForm: true
  };
}

function receiveAddForm(addingFormResults) {
  return {
    type: ADD_FORM_SUCCESS,
    isAddingForm: false,
    addingFormResults
  };
}

function rejectAddForm(addingFormResults) {
  return {
    type: ADD_FORM_FAILURE,
    isAddingForm: false,
    addingFormResults
  };
}

function resetAddForm() {
  return {
    type: RESET_ADDING_FORM,
    addingFormResults: null
  };
}

export function addForm(imyTier, data, onlineForm) {
  const permanentCustomer = data.customerObject?.createPermanentCustomer || null;
  const postData = {
    parentAccountId: imyTier?.accountId || null,
    isOnline: onlineForm,
    client: data.clientId,
    legalEntities: data.customerObject && data.customerObject.legalEntities ? data.customerObject.legalEntities.map(le => le.value) : [],
    wFormReference: data.wFormReference,
    crsFormReference: data.crsFormReference,
    fatcaCrsFormReference: data.fatcaCrsFormReference,
    carfFormReference: data.carfFormReference,
    customerId: imyTier && data.imyParentCustomer ? data.imyParentCustomer.id : data.customerObject && data.customerObject.customerId,
    accounts: data.customerObject && data.customerObject.accounts && data.customerObject.accounts.length > 0 ? data.customerObject.accounts.map(a => a.value) : [],
    isNewAccount: data.customerObject !== null && data.customerObject.newAccount,
    isNewCustomer: !imyTier && data.customerObject !== null && data.customerObject.newCustomer,
    customerType: data.customerType,
    usNonUs: data.usNonUs,
    wForm: (((imyTier && data.addImyLayer))
      || (data.customerObject && (data.customerObject.customerId || data.customerObject.newCustomer || permanentCustomer) && (data.wForms && data.wForms.length > 0))) ? {
        type: data.formType,
        forms: data.wForms,
        date: data.wFormDate
      } : null,
    crsForm: (data.crsForms && data.crsForms.length > 0) ? {
      type: data.crsFormType,
      forms: data.crsForms,
      date: data.crsFormDate
    } : null,
    fatcaCrsForm: (data.fatcaCrsForms && data.fatcaCrsForms.length > 0) ? {
      type: data.fatcaCrsFormType,
      forms: data.fatcaCrsForms,
      date: data.fatcaCrsFormDate
    } : null,
    carfForm: (data.carfForms && data.carfForms.length > 0) ? {
      type: data.carfFormType,
      forms: data.carfForms,
      date: data.carfFormDate
    } : null,
    imy: !permanentCustomer && !data.customerObject?.permanentCustomerRetry && (imyTier || (!imyTier
      && !onlineForm && data.formType && data.formType.indexOf('imy') !== -1)) ? {
        statementType: data.whdStatementType,
        statement: data.whdStatement && data.whdStatement.file,
        statementFormat: data.whdStatement?.statementFormat || data.statementFormat || null,
        accountGuid: data.imyAccountGuid,
        beneficiaryForms: data.benefForms,
        imyReplacement: (imyTier && !data.addImyLayer && data.wForms && data.wForms.length > 0 && {
          ...data.wForms[0],
          accountId: imyTier.accountId,
          accountName: imyTier.accountName,
          customerDbId: imyTier.customerDbId,
          customerName: imyTier.customerName,
        }) || null
      } : null,
    supportingDocs: {
      documents: data.supportingDocs,
      originEmail: data.originEmail
    },
    createPermanentCustomer: permanentCustomer
  };

  return (dispatch) => {
    dispatch(requestAddForm());

    const promise = () => ApiService
      .addForm(postData)
      .then((response) => {
        if (response.data.redirectUrl) {
          dispatch(hideAddFormModal());
          return dispatch(push(response.data.redirectUrl));
        }
        return dispatch(receiveAddForm(response.data));
      })
      .catch((error) => {
        if (error.response && error.response.config) {
          error.response.config = { ...error.response.config, data: undefined };
        }
        if (error.response) {
          dispatch(handleException(error, rejectAddForm));
        } else {
          error.errorMessage = 'There was a problem communicating with the server. Please check the status of your uploaded form.';
          dispatch(handleException(error, rejectAddForm));
        }
      });
    return promise();
  };
}

export function hideAddFormResults() {
  return dispatch => dispatch(resetAddForm());
}
